<template>
  <div class="avatar mr-2" :style="`background-color: ${finalColor}`">
    {{ content }}
    <i v-if="!content" class="fas fa-user text-white user-icon"></i>
  </div>
</template>

<script>
import { shuffleArray } from "../lib/helpers.js";
const avatarColorPalette = shuffleArray([
  "#0F3B95",
  "#006607",
  "#5B089B",
  "#9C2AF4",
  "#99FFA0",
  "#864E09",
  "#F1911B",
  "#DE0000",
  "#FFDA33",
  "#00778F",
  "#00CCF5",
  "#FF8585",
  "#333AFF",
  "#C2C4FF",
  "#FFEC99",
  "#276FFF",
  "#9CA4AA",
]);

export default {
  props: {
    content: { type: String, default: "" },
    id: { type: [Number, String], default: null },
    color: { type: String, default: null },
  },
  data: function () {
    return {
      generatedColor: "",
      avatars: {},
    };
  },
  computed: {
    finalColor() {
      // If the color prop is provided, use it. Otherwise, use the generated color.
      // A fallback gray is used if nothing is set yet.
      return this.color || this.generatedColor || "#9CA4AA";
    },
  },
  watch: {
    id: function (newValue, oldValue) {
      if (newValue !== oldValue && !this.color) {
        this.getAvatarColor();
      }
    },
  },
  mounted() {
    if (!this.color) {
      this.loadAvatars();
      this.getAvatarColor();
    }
  },
  methods: {
    loadAvatars() {
      const avatarsCache = localStorage.getItem("serviceshift-avatars");
      if (avatarsCache) {
        this.avatars = JSON.parse(avatarsCache);
      }
    },
    getAvatarColor() {
      if (this.avatars[this.id]) {
        this.generatedColor = this.avatars[this.id].color;
        return;
      }
      this.generateNewAvatar();
    },
    generateNewAvatar() {
      const colorsInUse = Object.keys(this.avatars)
        .filter((key) => this.avatars[key].color)
        .map((key) => this.avatars[key].color);

      let colors = [...avatarColorPalette].filter(
        (color) => !colorsInUse.includes(color)
      );
      if (colors.length === 0) {
        colors = shuffleArray([...avatarColorPalette]);
      }

      const newColor = colors.shift();

      this.avatars = {
        ...this.avatars,
        [this.id]: {
          content: "",
          color: newColor,
        },
      };

      localStorage.setItem(
        "serviceshift-avatars",
        JSON.stringify(this.avatars)
      );

      this.generatedColor = this.avatars[this.id].color;
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.2rem;
}
</style>
